import React, { memo } from 'react';

function ViewList({ color = '#335B70', ...props }) {
    return (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="3" y="7" width="2" height="2" fill={color} />
            <rect x="7" y="7" width="14" height="2" fill={color} />
            <rect x="3" y="11" width="2" height="2" fill={color} />
            <rect x="7" y="11" width="14" height="2" fill={color} />
            <rect x="3" y="15" width="2" height="2" fill={color} />
            <rect x="7" y="15" width="14" height="2" fill={color} />
        </svg>
    );
}

export default memo(ViewList);
